import React, {useEffect, useState} from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { APP_VERSION_NUMBER } from '../../api/common';
import { fetchServerVersion } from '../../api/user';
import { ServerVersionResponse } from '../../domain/domain';
const useStyles = makeStyles((theme) => ({
  footerRoot: {
    borderTop: "1px solid #2e9e9e",
    paddingRight: '10px',
    paddingLeft: '10px',
    marginTop: '10px',
    minHeight: "50px",
    backgroundColor: '#fff',
  },
}));

const Footer = () => {
  const classes = useStyles();
  const [serverVersion, setServerVersion] = useState<string>('');

  useEffect(() => {
    fetchServerVersion().then((response) => {
      const data: ServerVersionResponse = response.data;
      const version = data?.build?.version;

      if (version) {
        setServerVersion(version);
      } else {
        console.error("Server Version is undefined");
      }
    }).catch((error) => {
      console.error("Failed to fetch server version:", error);
    });
  }, []);

  return (
    <footer>
      <Grid container direction='row' spacing={1} className={classes.footerRoot} justifyContent="flex-end" alignItems='center'>
        <Grid item>
          <Typography variant='body1' color={'textSecondary'}>
            UI Version: {APP_VERSION_NUMBER} | Server Version: {serverVersion}
          </Typography>
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
